import React, { useState } from 'react';
import './CalculatorPage.css';

function VehicleCarNumberAnalysis() {
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzeNumber = (number) => {
    // Placeholder for Vehicle/Car Number Analysis logic
    // This is a simplified example; real analysis would be more complex.
    if (!number) return null;
    let sum = 0;
    const numStr = number.toUpperCase().replace(/[^A-Z0-9]/g, '');

    const charMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < numStr.length; i++) {
      const char = numStr[i];
      if (!isNaN(parseInt(char, 10))) {
        sum += parseInt(char, 10);
      } else if (charMap[char]) {
        sum += charMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return `The numerological value of your vehicle number is ${sum}. This is a placeholder explanation for vehicle number analysis.`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!vehicleNumber) {
      setError('Please enter a vehicle number.');
      return;
    }

    const calculated = analyzeNumber(vehicleNumber);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Vehicle/Car Number Analysis",
    "description": "Analyze your vehicle or car number for numerological insights.",
    "url": "https://www.yourwebsite.com/vehicle-car-number-analysis",
    "potentialAction": {
      "@type": "AnalyzeAction",
      "name": "Analyze Vehicle/Car Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/vehicle-car-number-analysis?number={vehicleNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=vehicleNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Vehicle/Car Number Analysis</h1>
      <p className="text-center">Enter your vehicle number to get a numerological analysis.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="vehicleNumber">Vehicle Number:</label>
          <input
            type="text"
            id="vehicleNumber"
            className="form-control"
            value={vehicleNumber}
            onChange={(e) => setVehicleNumber(e.target.value)}
            placeholder="e.g., DL 1C AB 1234"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Analysis:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default VehicleCarNumberAnalysis;
